<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { Navigation } from '../../utilities/Navigation';

    import { api, clientSettings } from '../../../stores/api';
    import { ColumnSettingsApi } from './ColumnSettingsApi';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { mainMenu } from '../../../stores/store';
    import { currentImport, ImportResponseSchema } from '../../shared/ColumnSelectPro/currentImport';
    import { ImportApi } from '../Import/ImportApi';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import { debug } from '../../../stores/store';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import ColumnSelectManager from '../../shared/ColumnSelectPro/ColumnSelectManager.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import { openModal } from 'svelte-modals';
    import ModalError from '../../shared/Modals/ModalError.svelte';

    import mockImportShort from './mock/importShort.json';
    import { SelectManager } from '../../shared/ColumnSelectPro/SelectManager';
    import InputText from '../../shared/InputText.svelte';
    import Select from '../../shared/Select.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import { VALIDATE } from './types';

    let allowGoNext = false;
    let reasons: string[] = [];
    let loading: boolean = true;
    let processing: boolean = false;
    let error: string = '';
    let intervalHandler: any = null;

    let sm: SelectManager = new SelectManager();

    /* $currentImport is null before fetching data from API */
    /* $currentImport.columns_assigment is null before columns are assigned by API (default settings) */

    function onValidate(isValidated: boolean, _reasons: string[]) {
        allowGoNext = isValidated;
        reasons = _reasons;
        console.log('AssignColumns: onValidate', isValidated, reasons);
    }

    function tryToGetColumnSettingsWithTimeout() {
        function tryToGetColumnSettings() {
            if ($currentImport !== null) {
                loading = true;
                ImportApi.getOne($api, $currentImport.id)
                    .then(response => {
                        if (response !== null && response.columns_assignment !== null) {
                            ImportResponseSchema.parse(response);
                            // $currentImport = {...mockImportShort}
                            $currentImport = { ...response };
                            if ($currentImport?.columns_assignment) {
                                sm = sm.setFileType($currentImport.file_type);
                                sm = sm.set(
                                    $currentImport.columns_assignment.elements,
                                    $currentImport.columns_assignment.options,
                                    $currentImport.columns_assignment.sections
                                );
                            } else {
                                console.warn('AssignColumns: columns_assignment are empty!', response);
                            }
                            loading = false;
                        } else {
                            intervalHandler = setTimeout(tryToGetColumnSettings, 1000);
                        }
                    })
                    .catch(err => {
                        console.log('AssignColumns: Columns settings fetch error!', err);
                        loading = false;
                    });
            }
        }

        tryToGetColumnSettings();
    }

    function processColumnSettings() {
        console.log('AssignColumns: Columns settings update', $currentImport);
        if ($currentImport !== null && $currentImport.columns_assignment !== null) {
            processing = true;
            //ColumnSettingsApi.updateColumnSettings($api, $currentImport.id, $currentImport.columns_assignment).then( (response) => {
            let columns_assignment = {
                elements: sm.getElements(),
                sections: sm.getSections(),
                options: sm.getOptions(),
            };
            ColumnSettingsApi.update($api, $currentImport.id, { columns_assignment })
                .then(response => {
                    console.log('AssignColumns: Columns settings updated!', response);
                    if (response !== null && response?.columns_assignment !== null && typeof response.id === 'number') {
                        $currentImport = {
                            ...$currentImport,
                            columns_assignment: response.columns_assignment,
                        };
                    }
                    if ($currentImport && $currentImport.id !== null) {
                        Navigation.navigate(`/import-analyze`);
                        // ColumnSettingsApi.confirm($api, $currentImport.id)
                        //     .then(() => {
                        //         let link =
                        //             $mainMenu.items.find(item => item.id === 'PageGeocoding')?.to ||
                        //             '/';
                        //         console.info('AssignColumns: link', link);
                        //         Navigation.navigate(link);
                        //         processing = false;
                        //     })
                        //     .catch(err => {
                        //         console.warn('AssignColumns: data', $currentImport);
                        //         console.warn('AssignColumns: Columns settings confirm error!', err);
                        //         openModal(ModalError, { text: err });
                        //         processing = false;
                        //     });
                    }
                })
                .catch(err => {
                    console.warn('AssignColumns: data', $currentImport);
                    console.warn('AssignColumns: Columns settings update error!', err);
                    openModal(ModalError, { text: err });
                    processing = false;
                });
        }
    }

    onMount(() => {
        if ($currentImport === null) {
            console.log('AssignColumns: No file uploaded, redirecting to upload-file page');
            Navigation.navigate('/upload-file');
        }
        tryToGetColumnSettingsWithTimeout();

        return () => {
            if (intervalHandler) clearInterval(intervalHandler);
        };
    });
</script>

{#if $currentImport !== null}
    <TemplateStandard>
        <div slot="header" style="width: 100%;">
            <TemplateHeaderDuo>
                <div slot="main-header">
                    <TemplateRow>
                        <IconBack
                            on:click={() => {
                                window.history.back();
                            }}
                            scale={0.7}
                        />
                        {$_('Ustawienia kolumn')}
                    </TemplateRow>
                </div>
                <div slot="main-buttons" style="display: flex; justify-items: center;">
                    <ButtonMain text={$_('btn-next')} on:click={processColumnSettings} disabled={!allowGoNext || processing} />
                </div>
            </TemplateHeaderDuo>
        </div>
        <div slot="content">
            {#if error}
                <MessageDanger {error} />
            {/if}
            {#if loading}
                <Spinner />
            {:else}
                <div style="overflow-y: auto; overflow-x: hidden; margin: 20px 0; padding: 20px; ">
                    <div
                        style="display:flex; flex-direction:column; align-items: center; padding: 0 0 20px 0; font-size: 14px; column-gap: 10px;"
                    >
                        {#if !allowGoNext && reasons.length > 0}
                            {#if reasons.includes(VALIDATE.MISSING_XY_OR_CITY_STREET)}
                                <ErrorInline text={$_(VALIDATE.MISSING_XY_OR_CITY_STREET)} />
                            {/if}
                            {#if reasons.includes(VALIDATE.X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED)}
                                <ErrorInline text={$_(VALIDATE.X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED)} />
                            {/if}
                            {#if reasons.includes(VALIDATE.Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED)}
                                <ErrorInline text={$_(VALIDATE.Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED)} />
                            {/if}
                            {#if reasons.includes(VALIDATE.ERRORS_EXISTS)}
                                <ErrorInline text={$_(VALIDATE.ERRORS_EXISTS)} />
                            {/if}
                        {/if}
                        {#if $currentImport.columns_assignment !== null && false}
                            {#each $currentImport.columns_assignment.errors as error, index}
                                <TemplateRow justifyContent="flex-start">
                                    <div class="element-error">{$_(error)}</div>
                                </TemplateRow>
                            {/each}
                            {#each $currentImport.columns_assignment.warnings as warning, index}
                                <TemplateRow justifyContent="flex-start">
                                    <div class="element-warning">{$_(warning)}</div>
                                </TemplateRow>
                            {/each}
                        {/if}
                        <!--                            <Checkbox-->
                        <!--                                bind:checked={isSelectedDay}-->
                        <!--                                label={$_('')}-->
                        <!--                                disabled={false}-->
                        <!--                            />-->
                    </div>
                    {#if $currentImport.columns_assignment !== null}
                        {#if sm.isSet()}
                            <ColumnSelectManager bind:sm callbacks={{ onValidate }} />
                        {:else}
                            <Spinner />
                        {/if}
                    {:else}
                        <MessageDanger header={$_('This file could not be processed')} {error} />
                    {/if}
                </div>
            {/if}
        </div>
    </TemplateStandard>
{/if}

<style>
    .element-warning {
        background-color: #ffd7008f;
        border-radius: 4px;
        padding: 5px 9px 3px 9px;
    }
    .element-error {
        background-color: #ff00008f;
        border-radius: 4px;
        padding: 5px 9px 3px 9px;
    }
</style>
